import React from "reactn"
import { useStaticQuery, graphql } from "gatsby"
import { JsonLd } from '../jsonLd'

export function ProductSEO({
    metaTitle = "INGMARSON",
    metafields,
    product
}
) {
    const {
        site: { siteMetadata },
    } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteTitle
          siteTitleDefault
          siteUrl
          author
          siteLogo
          hrefLang
          siteDescription
          siteImage
          siteImageWidth
          siteImageHeight
          siteImage1
          siteImageWidth1
          siteImageHeight1
          twitter
        }
      }
    }
  `)

//   useEffect(() => {
//       alert("PRODUCT SEO")
//   }, [product])
    const {
        variants,
        fields,
        description,
        title,
        handle
    } = product

    const {
        suggestedGender,
        nowPlusOneYear,
        lastReviewed,
        releaseDate,
        slug
    } = fields


    const {
        color_name,
        price,
        sale_price,
        on_sale,
        social_image,
        social_images
    } = metafields

    console.log("SOCIAL IMAGE", social_image)
    console.log("SOCIAL IMAGES", social_images)
    // const {
    //     variants
    // } = product.variants

    // console.log("VAR", product.variants)
    const {
        siteTitleDefault,
        siteImageHeight,
        author,
        siteLogo,
        siteUrl,
        siteDescription,
        siteImage,
        twitter,
    } = siteMetadata


    //   const seo = {
    //     title: metaTitle ,
    //     description: metaDescription || siteDescription,
    //     url: siteUrl + (path ? path : location.pathname),
    //   }

    var images = []
    const socialImagesJSON = social_images ? JSON.parse(social_images) : null
    if (socialImagesJSON) {
        socialImagesJSON.forEach(socialImage => {
            images.push({
                '@type': 'ImageObject',
                url: siteUrl + '/static/' + socialImage.file,
                contentUrl: siteUrl + '/static/' + socialImage.file,
                height: socialImage.height,
                width: socialImage.width
            })
        });

    } else {
        images.push({
            '@type': 'ImageObject',
            url: social_image,            
            contentUrl: social_image,
            height: 1200,
            width: 630
        })
            
    }
    console.log("SOCIAL IMAGE OUTPUT", images)
    var JSONLdData = {
        '@context': "http://schema.org/",
        '@type': 'Product',
        "brand": {
            "@type": "Brand",
            "logo": siteUrl + siteLogo,
            "name": metaTitle,
            "url": siteUrl
        },
        "audience": {
            "@type": "PeopleAudience",
            "suggestedMinAge": "13",
            "suggestedGender": suggestedGender
        },
        "color": color_name,
        "offers": [],
        "url": siteUrl + slug,
        "priceCurrency": "GBP",
        "price": on_sale ? sale_price : price,
        "priceValidUntil": nowPlusOneYear,
        "itemCondition": "https://schema.org/NewCondition",
        "availability": "https://schema.org/InStock",
        "seller": {
            "@type": "Organization",
            "name": metaTitle
        },
        name: title ,
        image: images,
        description: description,
        // "mainEntityOfPage": {
        //     "@type": "WebPage",
        //     "@id": siteUrl,
        //     "breadcrumb": slug,
        //     "lastReviewed": lastReviewed,
        //     "author": author,
        //     "creator": author,
        //     "publisher": author,
        //     "accountablePerson": author,
        //     "dateModified": lastReviewed,
        //     "url": siteUrl + slug
        // },
        logo: siteUrl + siteLogo,
        identifier: handle,
        sku: handle,
        mpn: handle,
        productID: handle,
        releaseDate: releaseDate
    }
    // var variations = []
    if (variants) {
        // alert("YES")
        // variations.push(...schemaOrgJSONLD)
        variants.forEach(variant => {
            const sku = handle + "-" + variant.title.toLowerCase()
            JSONLdData.offers.push(
                {
                    "@type": "Offer",
                    "sku":  sku,
                    "url": siteUrl + slug,
                    "mpn":  sku,
                    "name": title + " (" + variant.title + ")",
                    "size": variant.title,
                    "priceCurrency": "GBP",
                    "price": on_sale ? sale_price : price,
                    "priceValidUntil": nowPlusOneYear,
                    "itemCondition": "https://schema.org/NewCondition",
                    "availability": variant.availableForSale ? "https://schema.org/InStock" : "https://schema.org/Discontinued",
                    "seller": {
                        "@type": "Organization",
                        "name": metaTitle
                    }
                }                
            )
        });
        console.log("VARIATIONS",  JSONLdData.offers)
    }

    return (

        <JsonLd >{JSONLdData}</JsonLd>
    )
}


